import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "pause-icon"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]


import MsButton from '@/components/general/buttons/MsButton.vue'

import play from '@/assets/svg/play.svg'
import pause from '@/assets/svg/pause.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayButton',
  props: {
  isPlayingLive: Boolean,
  isLiveActive: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (!__props.isLiveActive)
    ? (_openBlock(), _createBlock(MsButton, {
        key: 0,
        "button-custom-style": "play-btn"
      }, {
        default: _withCtx(() => [
          (!__props.isPlayingLive)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(play),
                class: "icon"
              }, null, 8, _hoisted_1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: _unref(pause),
                  class: "icon"
                }, null, 8, _hoisted_3),
                _createElementVNode("img", {
                  src: _unref(pause),
                  class: "icon"
                }, null, 8, _hoisted_4)
              ]))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})